import styled from "styled-components/macro";

import { TitleH2 } from "../../styles/sharedStyles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const CustomTitleH2 = styled(TitleH2)`
  max-width: 100%;
`
